import { render, staticRenderFns } from "./AppBug.vue?vue&type=template&id=22128c6c"
import script from "./AppBug.vue?vue&type=script&lang=js"
export * from "./AppBug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports